import { getDatadogInstance } from '@cw-elements/analytics-provider';

import { DATADOG_REGION, DATADOG_SERVICE, DATADOG_TEAM } from './constants';

/**
 * Applies the RUM setup the analytics provider does not perform itself: the
 * global context tags and the start of session replay recording. Call it once
 * the provider has initialized RUM.
 *
 * Context is set per key rather than with `setGlobalContext`, whose
 * whole-object replace would wipe context set by another owner.
 */
const applyDatadogRumSetup = () => {
  const rum = getDatadogInstance();

  if (!rum) {
    return;
  }

  rum.setGlobalContextProperty('team', DATADOG_TEAM);
  rum.setGlobalContextProperty('region', DATADOG_REGION);
  rum.setGlobalContextProperty('app_name', DATADOG_SERVICE);

  rum.startSessionReplayRecording();
};

export default applyDatadogRumSetup;
